"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Single = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const material_ui_1 = require("../material-ui");
const CssBaseline_1 = __importDefault(require("@material-ui/core/CssBaseline"));
const element_tracker_1 = require("@cs125/element-tracker");
const SavePosition_1 = require("../gatsby/SavePosition");
const react_helmet_1 = require("react-helmet");
const material_ui_2 = require("../material-ui/");
const react_2 = require("@mdx-js/react");
const material_ui_3 = require("../material-ui");
const element_tracker_2 = require("../element-tracker");
const material_ui_4 = require("../material-ui");
const mdx_1 = require("../mdx");
exports.Single = ({ title, description, logo, children }) => (react_1.default.createElement(material_ui_1.ThemeProvider, null,
    react_1.default.createElement(CssBaseline_1.default, null),
    react_1.default.createElement(element_tracker_1.ElementTracker, null,
        react_1.default.createElement(SavePosition_1.SavePosition, null),
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("meta", { charSet: "utf-8" }),
            react_1.default.createElement("title", null, title),
            react_1.default.createElement("meta", { name: "description", content: description }),
            react_1.default.createElement("script", { async: true, defer: true, src: "https://apis.google.com/js/platform.js" }),
            react_1.default.createElement("link", { rel: "preconnect", href: "https://fonts.gstatic.com" }),
            react_1.default.createElement("link", { rel: "preconnect", href: "https://accounts.google.com", crossOrigin: "use-credentials" }),
            react_1.default.createElement("link", { rel: "preconnect", href: "https://apis.google.com" }),
            react_1.default.createElement("link", { rel: "preconnect", href: "https://ssl.gstatic.com" }),
            react_1.default.createElement("link", { rel: "preconnect", href: "https://cdn.jsdelivr.net" })),
        react_1.default.createElement(element_tracker_1.UpdateHash, { filter: element => element.tagName.toLowerCase() === "h2" }),
        react_1.default.createElement(material_ui_2.TopBar, { title: react_1.default.createElement("code", null, title), logo: logo }),
        react_1.default.createElement(material_ui_3.StickyBar, { minWidth: 128, side: "right", center: "md" },
            react_1.default.createElement(element_tracker_2.SidebarMenu, null)),
        react_1.default.createElement(material_ui_4.MainContainer, null,
            react_1.default.createElement(react_2.MDXProvider, { components: mdx_1.components }, children)))));
exports.Single.propTypes = {
    title: prop_types_1.default.string.isRequired,
    description: prop_types_1.default.string.isRequired,
    logo: prop_types_1.default.any.isRequired,
    children: prop_types_1.default.node.isRequired,
};
//# sourceMappingURL=Single.js.map